import { Fragment } from 'react';

import useAthleteUserPurchases from './UseAthleteUserPurchases';

import AthleteUserPurchasesGrid from './AthleteUserPurchasesGrid';
import AthleteUserAdditionalPurchasesGrid from './AthleteUserAdditionalPurchasesGrid';

import Headings from '@usas/ui-web/components/headings/Headings';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import Constants from '@usas/ui-web/utils/Constants';

import style from '../../Entry.module.css';
import global from '@usas/ui-web/components/GlobalStyle.module.css';

const AthleteUserPurchasesWrite = () => {
  const { orgUnitAthleteEntryInfoState, omeMeetOrgUnitAthleteEntryIndividualRosterEntryState, omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState,
    orgUnitAthleteEntryPurchaseState, handleSubmit, errorState, onAdditionalPurchaseValueChanged, state,
    submitAthleteEntryAllowed, onBackClicked, modalState, onModalCanceled, onDeletePurchaseItemDetailClicked,
    onDeletePurchaseItem, onExitButtonClicked } = useAthleteUserPurchases();

  return (
    <Fragment>
      <div className={orgUnitAthleteEntryInfoState.objData.teamOrgUnitName === 'Unattached' ? global.DisplayComponent : global.HideComponent}>
        <div className="row">
          <div className="col-xs-12">
            <Headings.H5>Requirements to be able to Make Purchases and Submit Entry</Headings.H5>
          </div>
          <div className='col-xs-12 usas-extra-bottom-margin'>
            <ul style={{ marginLeft: '15px' }}>
              <li>At least one entry contact must be provided {orgUnitAthleteEntryInfoState.objData?.hasEntryContact === true ? <b>(Requirement Completed)</b> : <span style={{ color: 'red' }}>(Requirement Not Completed)</span>}</li>
              <li>Athlete must have a status of 'Events Approved' or 'Submitted' {orgUnitAthleteEntryInfoState.objData?.allowRelayOnlySwimmer === true ? "or 'Relay Only Swimmer'" : orgUnitAthleteEntryInfoState.objData?.allowRelayOnlySwimmer === false ? "('Relay Only Swimmer' status is not allowed)" : ''} {orgUnitAthleteEntryInfoState.objData?.hasApprovedEvents === true ? <b>(Requirement Completed)</b> : <span style={{ color: 'red' }}>(Requirement Not Completed)</span>}</li>
              <li>The number of credentials is allowed according to the meet's deck pass rules {orgUnitAthleteEntryInfoState.objData?.credentialsAmountAllowed === true ? <b>(Requirement Completed)</b> : <span style={{ color: 'red' }}>(Requirement Not Completed)</span>}</li>
            </ul>
          </div>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-xs-12">
              <Headings.H6>Required Purchases</Headings.H6>
            </div>
            <div className="col-xs-12">
              <AthleteUserPurchasesGrid
                gridData={orgUnitAthleteEntryPurchaseState.objData?.purchaseItem}
                isLoading={orgUnitAthleteEntryPurchaseState.isObjLoading}
                onDeletePurchaseItemDetailClicked={onDeletePurchaseItemDetailClicked}
              />
            </div>
            {orgUnitAthleteEntryPurchaseState.objData?.additionalPurchase?.length > 0 &&
              <Fragment>
                <div className="col-xs-12 usas-extra-top-margin">
                  <Headings.H6>Additional Purchases</Headings.H6>
                </div>
                <div className="col-xs-12">
                  <AthleteUserAdditionalPurchasesGrid
                    gridData={orgUnitAthleteEntryPurchaseState.objData?.additionalPurchase}
                    isLoading={orgUnitAthleteEntryPurchaseState.isObjLoading}
                    errorState={errorState}
                    onAdditionalPurchaseValueChanged={onAdditionalPurchaseValueChanged}
                  />
                </div>
              </Fragment>}
            <div className={state.showPayButton === true && submitAthleteEntryAllowed() === true ? global.DisplayComponent : global.HideComponent}>
              <div className={style.FloatRight}>
                <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
                  <SecondaryButton onClick={onBackClicked}>Back</SecondaryButton>&nbsp;
                  <PrimaryButton onClick={onExitButtonClicked}>Exit</PrimaryButton>&nbsp;
                  <PrimaryButton type="submit">{omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.status === Constants.WORKFLOW_STATUS_SUBMITTED ? 'Pay' : 'Pay & Submit'}</PrimaryButton>
                </div>
              </div>
            </div>
            <div className={state.showPayButton === false || submitAthleteEntryAllowed() === false ? global.DisplayComponent : global.HideComponent}>
              <div className={style.FloatRight}>
                <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
                  <SecondaryButton onClick={onBackClicked}>Back</SecondaryButton>&nbsp;
                  <PrimaryButton onClick={onExitButtonClicked}>Exit</PrimaryButton>
                </div>
              </div>
            </div>
          </div>
        </form>
        <PopUpModal
          widthPct={50}
          maxWidth={250}
          title={Constants.LOADING_MSG}
          displayPopUp={orgUnitAthleteEntryInfoState.isObjLoading === true || omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading === true ||
            omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState.isArrayLoading === true ||
            orgUnitAthleteEntryPurchaseState.isObjLoading === true || state.tryRedirect === true}
        />
        <PopUpModal
          widthPct={50}
          maxWidth={250}
          title={Constants.SAVING_MSG}
          displayPopUp={orgUnitAthleteEntryPurchaseState.isSaving}
        />
        <PopUpModal
          widthPct={90}
          maxWidth={720}
          title={modalState.modalTitle}
          displayPopUp={modalState.displayPopUp}
          onModalCanceled={onModalCanceled}>
          <div className="row">
            <div className='col-xs-12'>
              <p><strong>Item Description:</strong> {modalState.itemDescription}</p>
              <p><strong>Item Price:</strong> {modalState.itemPrice}</p>
            </div>
            <div className="col-xs-12 usas-extra-top-margin">
              <SecondaryButton type="button" onClick={onModalCanceled}>Cancel</SecondaryButton>&nbsp;
              <PrimaryButton type="button" onClick={(e) => onDeletePurchaseItem(e, modalState.referenceEntity, modalState.referenceId)}>Delete</PrimaryButton>
            </div>
          </div>
        </PopUpModal>
      </div>
      <div className={orgUnitAthleteEntryInfoState.objData.teamOrgUnitName === 'Unattached' ? global.HideComponent : global.DisplayComponent}>
        <div className={style.FloatRight}>
          <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
            <SecondaryButton onClick={onBackClicked}>Back</SecondaryButton>&nbsp;
            <PrimaryButton onClick={onExitButtonClicked}>Exit</PrimaryButton>
          </div>
        </div>
      </div>
    </Fragment >
  );
};

export default AthleteUserPurchasesWrite;